/** Ordered social platforms shown in salon browser (no WhatsApp). */
export const SOCIAL_LABELS = [
  { key: 'instagram', label: 'Instagram' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'tiktok', label: 'TikTok' },
];

/** Return [{ key, label, url }, ...] for non-empty links. */
export function entriesFromSocialObject(obj) {
  if (!obj || typeof obj !== 'object') return [];
  return SOCIAL_LABELS.map(({ key, label }) => {
    const url = obj[key];
    if (!url || typeof url !== 'string' || !url.trim()) return null;
    return { key, label, url: url.trim() };
  }).filter(Boolean);
}
